<template>
  <div class="card no-border widget-loader-circle no-padding rounded">
    <div class="card-header" :class="getShiftClass.box[shiftTypeId]">

    </div>
    <div class="card-body p-t-20 p-b-20">
      <div class="card-icon">
      </div>

      <div class="card-link">
        <router-link class="sectiontitle2 text-24-gray"
                     :to="linkTo">{{ $t(mainTitle) }}</router-link>
      </div>

      <div class="d-flex flex-row justify-content-between flex-wrap">
        <div class="open-survey-text p-t-10">
          <div class="survey-intro">
            <p>{{ subTitle }}</p>
          </div>
          <div class="round-date">
            <p><span class="text-dag"><strong v-html="content"></strong></span></p>
          </div>
        </div>

        <div v-if="linkTo">
          <button class="advicebutton confirm">
            <router-link class="text-white"
                         :to="linkTo">
              {{ buttonCaption }}
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['shiftTypeId', 'linkTo', 'mainTitle', 'subTitle', 'content', 'buttonCaption'],
    computed: {
      ...mapGetters([
        'getShiftClass',
      ]),
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/GenericHomeCard.vue